import * as React from 'react'
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  TextInput,
  FunctionField,
  useGetIdentity,
  TopToolbar,
  FilterButton,
  ExportButton,
  CreateButton,
  EditButton,
  ShowButton,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import { Chip } from '@material-ui/core'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'

const FilesFilters = [<TextInput key="name" source="name" />]

const CampaignsListActions = () => (
  <TopToolbar>
    <CreateButton />
    <FilterButton />
    <ExportButton />
  </TopToolbar>
)

const CampaignList = props => {
  const translate = useTranslate()
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>

  return (
    <List
      {...props}
      actions={<CampaignsListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={FilesFilters}
      pagination={<MyPagination />}
    >
      <Datagrid rowClick="show">
        <NumberField source="id" sortByOrder="DESC" />
        <TextField source="name" />
        <TextField source="country" />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <FunctionField
          label={translate('surveys.resources.questions')}
          render={record => {
            const count = (record.questionIds || []).length
            if (count === 0) {
              return (
                <Chip
                  size="small"
                  label={translate('surveys.campaigns.no_questions_short')}
                  style={{ backgroundColor: '#f1f5f9', color: '#64748b' }}
                />
              )
            }
            const first = (record.questionList || [])[0]
            const preview = first?.label?.[identity.country.toLowerCase()] || ''
            return (
              <Chip
                size="small"
                label={translate('surveys.campaigns.question_count', { count })}
                style={{ backgroundColor: '#e0f2fe', color: '#0369a1' }}
                title={preview}
              />
            )
          }}
        />
        <FunctionField
          label={translate('surveys.campaigns.first_question')}
          render={record => {
            const first = (record.questionList || [])[0]
            if (!first) return '—'
            return first.label?.[identity.country.toLowerCase()] || '—'
          }}
        />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  )
}

export default CampaignList
